import { TextField, BlockStack, Text, Button, Bleed, Divider } from '@shopify/polaris';
import React, { ReactElement } from 'react';
import { DI } from '../../../../Core';
import { useTranslation } from 'react-i18next';

function Steptwo(props: any): ReactElement {
    const { t } = useTranslation();
    function showCustomError() {
        if (props['account_name']?.length > 31)
            return true && t('Account name cannot exceed 32 characters.');
        if (props.errors.account_name) {
            if (props['account_name'] === '' || props['account_name'].trim().length === 0) {
                return true && t('Account name is missing, Please enter account name.');
            } else {
                return true && t('Account Name already exists, Please try again.');
            }
        }
    }

    return (
        <BlockStack gap="500">
            <BlockStack gap="200">
                <Text as="h2" variant="headingMd">
                    {t("Step")}{' '}
                    <Text as="span">
                        {props.steps_completed + 1}
                        <Text as="span" tone="subdued">/3{' '}</Text>
                    </Text>{' '}
                    : {t("Create an Account Name")}
                </Text>
                <Text as='p' tone='subdued'>{t("Create a unique name for this account to make sure that you can easily identify this account later on when you connect multiple accounts with your Shopify Store.")}</Text>
            </BlockStack>
            <Bleed>
                <Divider />
            </Bleed>
            <TextField
                label={t("Account name")}
                maxLength={32}
                showCharacterCount
                error={showCustomError()}
                value={props['account_name']}
                onChange={(event) => { props.updateState('account_name', '', '', event) }}
                autoComplete=''
                placeholder={t('Ex: storename_country')}
                requiredIndicator
            />
            <Button
                loading={props?.isLoading()}
                onClick={() => { props?.onSave() }}
                disabled={props?.['steps_completed'] == 0 ? true : false}
                variant="primary">{t(props?.getFooterActionText())}</Button>
        </BlockStack>
    );
}

export default DI(Steptwo);